import { Grid, styled } from '@cherre-frontend/ui';

export const HeaderGrid = styled(Grid)`
  > .MuiBox-root {
    flex-grow: 1;
  }
`;
